module.exports = __webpack_public_path__ + "static/bg03-ba71e8789be01b7ed300d01250d2a52e.png";